import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

const TOAST_BASE = 'bg-lGray850/95 border';

const TOAST_BORDER = {
  primary: '!border-lPrimary/40',
  success: '!border-lSuccess/40',
  info: '!border-lInfo/40',
  warn: '!border-lWarning/40',
  error: '!border-lDanger/40',
} as const;

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(private readonly messageService: MessageService) {}

  private readonly life: number = 4000;

  public primary(message: string, title?: string, icon?: string): void {
    this.messageService.add({
      summary: title,
      detail: message,
      contentStyleClass: `${TOAST_BASE} ${TOAST_BORDER.primary}`,
      icon: icon ?? 'info',
      severity: '',
      ...this.base,
    });
  }

  public success(message: string, title?: string, icon?: string): void {
    this.messageService.add({
      summary: title,
      detail: message,
      contentStyleClass: `${TOAST_BASE} ${TOAST_BORDER.success}`,
      icon: icon ?? 'check_circle',
      severity: '',
      ...this.base,
    });
  }

  public info(message: string, title?: string, icon?: string): void {
    this.messageService.add({
      summary: title,
      detail: message,
      contentStyleClass: `${TOAST_BASE} ${TOAST_BORDER.info}`,
      icon: icon ?? 'info',
      severity: '',
      ...this.base,
    });
  }

  public warn(message: string, title?: string, icon?: string): void {
    this.messageService.add({
      summary: title,
      detail: message,
      contentStyleClass: `${TOAST_BASE} ${TOAST_BORDER.warn}`,
      icon: icon ?? 'warning',
      severity: '',
      ...this.base,
    });
  }

  public error(message: string, title?: string, icon?: string): void {
    this.messageService.add({
      summary: title,
      detail: message,
      contentStyleClass: `${TOAST_BASE} ${TOAST_BORDER.error}`,
      icon: icon ?? 'error',
      severity: '',
      ...this.base,
    });
  }

  private get base(): Record<string, unknown> {
    return {
      life: this.life,
      sticky: false,
      closeIcon: undefined,
      closable: false,
      styleClass: 'toast',
    };
  }

}
